import React, { useEffect } from 'react';
import { useQuery } from 'hooks/apollo';
import { gql } from '@apollo/client';
import { useParams } from 'react-router-dom';
import { Result, Button } from 'antd';

import Hero from 'components/Hero';

const QUERY = gql`
  query($reportId: ID!, $format: ReportFileFormat!, $date: String!) { 
    report(id: $reportId) {
      id
      fileName(format: $format, date: $date)
    }
  }
`;

const link = document.createElement('a');

const DownloadReport = () => {
  const { format, reportId, date } = useParams();
  const { loading, error, data: { report } = {} } = useQuery(
    QUERY,
    { variables: { reportId, format: format.toUpperCase(), date } },
  );

  useEffect(() => {
    if (report?.fileName) {
      link.href = `${process.env.REPORT_BASE_PATH}/download/${report.fileName}`;
      link.download = report.fileName.split('/').pop();
      link.click();
    }
  }, [report]);

  let status;
  let title;
  let subTitle;
  let extra;

  if (loading) {
    status = 'info';
    title = 'Download report';
    subTitle = 'Creating your file...';
  } else if (error) {
    status = 'error';
    title = 'Download report';
    subTitle = 'Something went wrong, please try again later.';
  } else if (report?.fileName) {
    status = 'success';
    title = 'Download report';
    subTitle = 'Your file should begin downloading automatically, if not click the button below.';
    extra = (
      <Button type="primary" onClick={() => link.click()}>
        Download
      </Button>
    );
  } else {
    status = 'info';
    title = 'Report not ready';
    subTitle = 'Your report has not been created yet, please try again in moment.';
  }

  return (
    <Hero>
      <Result
        status={status}
        title={title}
        subTitle={subTitle}
        extra={extra}
      />
    </Hero>
  );
};

export default DownloadReport;
